export const SET_COUNT = 'SET_COUNT';
export const UPDATE_WORDS = 'UPDATE_WORDS';
export const SET_CURRENT_CARD = 'SET_CURRENT_CARD';
export const SET_CURRENT_WORD = 'SET_CURRENT_WORD';
export const ADD_RIGHT_WORD = 'ADD_RIGHT_WORD';
export const ADD_WRONG_WORD = 'ADD_WRONG_WORD';
export const NULLIFY = 'NULLIFY';
export const SET_PENDING = 'SET_PENDING';
export const SET_LEVEL = 'SET_LEVEL';
export const SET_PAGE = 'SET_PAGE';
export const SET_BEST_LINE = 'SET_BEST_LINE';
export const SET_CURRENT_LINE = 'SET_CURRENT_LINE';
export const SET_PERCENT = 'SET_PERCENT';
export const SET_IS_CHECK = 'SET_IS_CHECK'; 
export const SET_VALUE_HEARTS = 'SET_VALUE_HEARTS'; 
export const SET_IS_SOUND = 'SET_IS_SOUND'; 

